import type { BinaryDependencyConfidence } from '../binaryDependencyConfidence';
import type { Fetcher } from '../fetchers';
import type { CommonAPITeamIdFilter, CommonTeamIdFilter } from '../permissions/filterHelpers';
import type { DependencySource } from '../vendoredDependencies';

import type { Status as StatusFilterOptions } from './common';

export { Status as StatusFilterOptions } from './common';

export type DependencyPagination = {
  page?: number;
  count?: number;
}

export enum DepthFilterOptions {
  Direct = 'direct',
  Transitive = 'transitive',
}

export enum LayerDepthFilterOptions {
  Base = 'base',
  Other = 'other',
}

export enum HasIssuesFilterOptions {
  HasIssues = 'hasIssues',
  HasLicensingIssues = 'hasLicensingIssues',
  HasQualityIssues = 'hasQualityIssues',
  HasVulnIssues = 'hasVulnIssues',
  NoIssues = 'noIssues',
}

export enum DependencyFilterKeys {
  /**
   * Filter by exact *dependency* locator match.
   */
  Locators = 'locators',
  Title = 'title',
  Status = 'status',
  Depth = 'depth',
  Confidence = 'confidence',
  LayerDepth = 'layerDepth',
  HasIssues = 'hasIssues',
  Licenses = 'licenses',
  Fetchers = 'fetchers',
  ShowIgnored = 'showIgnored',
  RootProjects = 'rootProjects',
  PackageLabels = 'packageLabels',
  /**
   * Filter by locator prefix (since package labels might apply to entire projects).
   * This value is derived from 'packageLabels' and not used directly.
   */
  PackageLocators = 'packageLocators',
  /**
   * Filter by 'vendored' or 'managed'
   */
  Sources = 'sources',
}

export type DependencyFilters = {
  [DependencyFilterKeys.Locators]?: string[];
  [DependencyFilterKeys.Title]?: string;
  [DependencyFilterKeys.Status]?: StatusFilterOptions[];
  [DependencyFilterKeys.Depth]?: DepthFilterOptions[];
  [DependencyFilterKeys.Confidence]?: BinaryDependencyConfidence[];
  [DependencyFilterKeys.LayerDepth]?: LayerDepthFilterOptions[];
  [DependencyFilterKeys.HasIssues]?: HasIssuesFilterOptions[];
  [DependencyFilterKeys.Licenses]?: string[];
  [DependencyFilterKeys.Fetchers]?: Fetcher[];
  [DependencyFilterKeys.ShowIgnored]?: boolean;
  [DependencyFilterKeys.RootProjects]?: string[];
  [DependencyFilterKeys.PackageLabels]?: string[];
  [DependencyFilterKeys.PackageLocators]?: string[];
  [DependencyFilterKeys.Sources]?: DependencySource[];
}

type DepManagerVersionOptions = {
  v?: '2' | '3';
}

export type DependencyQueryWithFilters = DependencyFilters & DependencyPagination & DepManagerVersionOptions;

export enum ProjectFilterKeys {
  TeamIds = 'teamIds',
}
export type APIProjectFilters = {
  [ProjectFilterKeys.TeamIds]: CommonAPITeamIdFilter;
}

export type ProjectFilters = {
  [ProjectFilterKeys.TeamIds]?: CommonTeamIdFilter;
}
